import { render, staticRenderFns } from "./moveGroupingModal.vue?vue&type=template&id=f79c0e8a&scoped=true"
import script from "./moveGroupingModal.vue?vue&type=script&lang=js"
export * from "./moveGroupingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79c0e8a",
  null
  
)

export default component.exports